import gql from "graphql-tag";

const getIndicatorByObjectiveAll = gql`
  query Indicator($objectiveId: Int!) {
    indicatorsByObjective(objectiveId: $objectiveId) {
      id
      code
      name
      description
      calculation
      baseline
      periodicity
      initialDate
      endDate
      weighing
      globalGoal
      tendency
      paramType
      objective {
        id
      }
      area {
        id
      }
      measure {
        id
        description
        name
      }
      goals {
        period
        real
        value
        id
      }
      additions {
        id
        name
        file
        amount
        note
        comment
        type
      }
    }
  }
`;
const getIndicatorByObjective = gql`
  query Query($args: FilterParamsInput) {
    searchIndicators(args: $args) {
      data {
        id
        code
        name
        description
        calculation
        baseline
        periodicity
        initialDate
        endDate
        weighing
        globalGoal
        tendency
        paramType
        objectiveId
        areaId
        area {
          id
          name
          description
          isActive
        }
        measureId
        measure {
          id
          name
          description
        }
        goals {
          id
          period
          value
          real
        }
        additions {
          id
          name
          file
          amount
          note
          comment
          type
          comments {
            id
            comment
            createdAt
          }
          files {
            id
            name
            description
            path
            createdAt
          }
        }
        objective {
          id
          name
        }
      }
      metadata {
        hasNextPage
      }
    }
  }
`;

export { getIndicatorByObjective }